export default __webpack_public_path__ + "static/media/banner-1-3.54602bb1.png";